import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47e2819a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents shadow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-main" }, [
  /*#__PURE__*/_createElementVNode("p", null, "内容をご確認いただき、よろしければ送信してください。")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "contents-form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "short-hr" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "short-hr" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "short-hr" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "contents-form" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "contents-form" }
const _hoisted_12 = { class: "navigation" }
const _hoisted_13 = { class: "navigation-button" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 戻る ", -1))
const _hoisted_15 = { class: "navigation-button" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 申出を送信 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemConfirm = _resolveComponent("ItemConfirm")!
  const _component_UrlConfirm = _resolveComponent("UrlConfirm")!
  const _component_CollectInfoConfirm = _resolveComponent("CollectInfoConfirm")!
  const _component_PermissionConfirm = _resolveComponent("PermissionConfirm")!
  const _component_UserDataConfirm = _resolveComponent("UserDataConfirm")!
  const _component_OthersConfirm = _resolveComponent("OthersConfirm")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ItemConfirm, {
        modelValue: _ctx.autoCollectOnlineData,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.autoCollectOnlineData) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_5,
      _createVNode(_component_UrlConfirm, {
        modelValue: _ctx.autoCollectUrl,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.autoCollectUrl) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_6,
      _createVNode(_component_CollectInfoConfirm, {
        modelValue: _ctx.regularlyCollect,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.regularlyCollect) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_7,
      _createVNode(_component_PermissionConfirm, {
        modelValue: _ctx.permission,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.permission) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_UserDataConfirm, {
        modelValue: _ctx.autoCollectApplicant,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.autoCollectApplicant) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_OthersConfirm, {
        modelValue: _ctx.others,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.others) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.backToInput,
          onKeydown: _withKeys(_withModifiers(_ctx.backToInput, ["prevent"]), ["space","enter"]),
          buttonId: 'button-back'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DssIcon, {
              icon: "arrow-left",
              style: {"font-size":"18px"}
            }),
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.send,
          onKeydown: _withKeys(_withModifiers(_ctx.send, ["prevent"]), ["space","enter"]),
          styled: 'is-accent',
          buttonId: 'button-send',
          disabled: !_ctx.sendData.autoCollectOnlineData
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown", "disabled"])
      ])
    ])
  ]))
}